import _extends from "@babel/runtime/helpers/extends";
import '../../css-tokens';
import React, { forwardRef } from 'react';
import cx from 'classnames';
import Base from '../Base';
import styles from './index.module.css';
const Hidden = /*#__PURE__*/function () {
  const Hidden = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      className,
      above,
      below,
      screen,
      print,
      ...rest
    } = _ref;
    const classnames = {
      // Screen
      [styles.screen]: !!screen,
      // Print
      [styles.print]: !!print,
      // Above
      [styles.aboveXs]: above === 'xs',
      [styles.aboveSm]: above === 'sm',
      [styles.aboveMd]: above === 'md',
      [styles.aboveLg]: above === 'lg',
      // Below
      [styles.belowSm]: below === 'sm',
      [styles.belowMd]: below === 'md',
      [styles.belowLg]: below === 'lg',
      [styles.belowXl]: below === 'xl'
    };
    return /*#__PURE__*/React.createElement(Base, _extends({
      ref: ref,
      className: cx(classnames, className) || undefined
    }, rest));
  });
  Hidden.displayName = 'Hidden';
  Hidden.identifier = Hidden.displayName;
  Hidden.clonableProps = [];
  Hidden.defaultProps = {};
  return Hidden;
}();
export default Hidden;